module.exports = __webpack_public_path__ + "media/images/backgrounds/story-fd9bf9d2b440a588995759885ed37dc90732c23e788bf0d297f1b4279e0de5fb.jpg";